<template>
  <div class="content-container">
    <!--头部文字-->
    <div class="list-title">
      <el-page-header @back="$router.back()" content="MQTT服务配置"></el-page-header>
    </div>

    <!--项目编辑内容-->
    <div class="content-box">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px">
        <el-form-item label="服务类型">
          <span style="font-weight: bold;padding: 0 10px;">{{ ruleForm.type }}</span>
        </el-form-item>
        <el-form-item label="业务模板">
          <span style="font-weight: bold;padding: 0 10px;">{{ ruleForm.businessName }}</span>
        </el-form-item>
        <el-form-item label="服务名称" prop="name">
          <el-input v-model="ruleForm.name" style="width: 33%;min-width:350px;"></el-input>
        </el-form-item>

        <div class="form-link"></div>
        
        <el-form-item label="设置账户" prop="username">
          <el-input v-model="ruleForm.username" style="width: 33%;min-width:350px;"></el-input>
        </el-form-item>
        <el-form-item label="设置密码" prop="password">
          <el-input v-model="ruleForm.password" :show-password="false" style="width: 33%;min-width:350px;"></el-input>
        </el-form-item>
        <el-form-item label="发布Topic" prop="topic">
          <el-input v-model="ruleForm.topic" style="width: 33%;min-width:350px;"></el-input>
        </el-form-item>

        <el-form-item label="消息格式" prop="dataType">
          <el-select v-model="ruleForm.dataType" placeholder="请选择" style="width: 33%;min-width:350px;">
            <el-option
              v-for="item in dataTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>                

        <el-form-item label="消息属性" >
          <div style="padding: 10px;width: 720px;">
            <el-table :data="attrList" height="450" border >
              <el-table-column prop="name" label="属性名称" width="300">
                <template slot-scope="scope">
                  <template v-if="scope.row.reserve==1"><span v-text="scope.row.name"></span><span style="color:#f52828">&nbsp;&nbsp;(预留属性)</span></template>
                  <el-input v-else v-model="scope.row.name" placeholder="请输入属性名称"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="rmk" label="备注属性说明" width="300">
                <template slot-scope="scope">
                  <template v-if="scope.row.isadd==0"><span v-text="scope.row.rmk"></span></template>
                  <el-input v-if="scope.row.isadd==1" v-model="scope.row.rmk" placeholder="请输入属性名称"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <template v-if="scope.row.isadd==0"><span style="color:#f52828">&nbsp;&nbsp;(必填属性)</span></template>
                  <el-button v-if="scope.row.isadd==1" type="text" @click="deleteAttr(scope.$index, scope.row)" size="small">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-button @click="addAttrList" style="position: absolute;left: 760px;top: 10px;" type="success">添加加属性</el-button>
        </el-form-item>


        <el-form-item>
          <el-button @click="$router.back()">取消</el-button>
          <el-button type="primary" @click="onSubmit('ruleForm')">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default{
  data() {
    return {
      ruleForm: {
        id: "",
        proType: "",
        type:"",
        name:"mqtt数据上报",
        business:"",
        businessName: "",
        proid: "",
        topic: "",
        qos: "1",
        dataType: "json",
      },      
      attrList:[],
      dataTypeList: [{name:"json",value:"json"}],
      additiveAttrs:["varchar1","varchar2","varchar3","varchar4","varchar5","varchar6","varchar7","varchar8","varchar9","varchar10",
      "varchar11","varchar12","varchar13","varchar14","varchar15","varchar16","varchar17","varchar18","varchar19","varchar20"],
      config: {
        
      },
      rules:{
        name: [
          { required: true, message: '请输入服务名称', trigger: 'blur' }
        ],
        username:[
          {required: true, message: '请设置账号', trigger: 'blur'}
        ],
        password:[
          {required: true, message: '请设置密码', trigger: 'blur'}
        ],
        topic:[
          {required: true, message: '请设发布Topic', trigger: 'blur'}
        ],
        dataType:[
          {required: true, message: '请选择消息格式', trigger: 'blur'}
        ],
      },
    };
  },
  methods: {
    isrequFormatter(row, column){
      if(row.fixed==1){
        return "必填";
      }else {
        return "非必填";
      }
    },
    addAttrList(){
      if(this.additiveAttrs.length > 0){
        let attr = this.additiveAttrs.splice(0, 1)
        this.attrList.push({
          "name": "",
          "rmk": "属性名称",
          "fixed": "0",
          "isadd": "1",
          "tabattr": attr[0]
        });
      }else{
        this.$message({
          message: '添加属性到达上限',
          type: 'warning'
        });
      }
    },
    deleteAttr(index, row){
      this.additiveAttrs.push(row.tabattr);
      this.attrList.splice(index, 1)
    },
    onSubmit(formName){
      let _this = this;      
      this.$refs[formName].validate((valid) => {
        if (valid) {
          submit();
        } else {
          return false;
        }
      });
      function submit(){        
        let formData = new FormData();
        formData.append("id", _this.ruleForm.id);
        formData.append("proType", _this.ruleForm.proType);
        formData.append("type", _this.ruleForm.type);
        formData.append("name", _this.ruleForm.name);
        formData.append("business", _this.ruleForm.business);
        
        _this.config.username = _this.ruleForm.username;
        _this.config.password = _this.ruleForm.password;
        _this.config.topic = _this.ruleForm.topic;
        _this.config.qos = _this.ruleForm.qos;
        _this.config.dataType = _this.ruleForm.dataType;
        let dataMap = {
          config: _this.config,
          attrs: _this.attrList,
        }
        // formData.append("param", JSON.stringify(dataMap));

        formData.append("configText", JSON.stringify(dataMap));

        var uid = getCookieV('userid1');
        var token = getCookieV('token1');
        _this.axios({
          method: 'post',
          url: _this.api.saveServerProject,
          data: formData,
          params: {
            uid: uid,
            tk: token,
          },
        }).then(function(res){
          console.log(res);
          let data=res.data;
          if(data.code==-1){
              window.location.href=_this.api.loginHtmlUrl;
          }else if(data.code==200){
            _this.$message({
              message: '保存成功!',
              type: 'success'
            });
            _this.$router.push({name: 'list'});
          }else{
            _this.$message.error(data.msg);
          }
        }).catch(function(){
            commonErrorTip(_this);
        })
      }
    }
  },
  created() {
    
  },
  mounted() {
    let _this = this;

    _this.$store.state.mainLeftMenu=1;
    var uid = getCookieV('userid1');
    var token = getCookieV('token1');
    
    var query = _this.$route.query;
    if(query.id != null && !(query.id === undefined) && !(query.id === "")){
      _this.axios({
        method: 'get',
        url: _this.api.queryByIdServerProject+"/"+query.id,
        params: {
          uid: uid,
          tk: token,
        },
      }).then(res=>{
        let data = res.data;
        if(data.code==200){
          let rf = data.data;
          let dm = JSON.parse(rf.configText);
          _this.config = dm.config;
          _this.attrList = dm.attrs;
          
          rf.username = _this.config.username;
          rf.password = _this.config.password;
          rf.topic = _this.config.topic;
          rf.qos = _this.config.qos;
          rf.dataType = _this.config.dataType;

          _this.ruleForm = rf;

          _this.ruleForm.businessName = _this.$store.state.businessList[_this.ruleForm.business].name;
        }else if(data.code==-1){
            window.location.href=_this.api.loginHtmlUrl;
        }else{
          _this.$message.error(data.msg);
        }
      }).catch(function(err){
        console.log(err);
        commonErrorTip(_this);
      })
    }else{
      _this.ruleForm.proType = query.proType;
      _this.ruleForm.type = query.type;
      _this.ruleForm.business = query.business;
      _this.ruleForm.businessName = _this.$store.state.businessList[_this.ruleForm.business].name;
    }
  },
  // watch: {
  //   ruleForm: {
  //     deep: true,
  //     handler: function(newV, oldV) {
  //       console.log('counter change to %o from %o', newV, oldV);
  //     }
  //   }
  // }
};
</script>
<style lang="scss" scoped>
.list-div {
  position: relative;
  padding: 0 0 0 30px;
  height: 850px;
  width: 90%;
  left: 80px;
}
.list-title {
  position: relative;
  // left: 15px;
  font-size: 20px;
  color: #333;
  padding: 10px;
  border-bottom: 1px solid #dadada;
}
.steps-div{
  height: 300px;
  width: 200px;
  // background-color: #ffffff;
}
.edit-div{
  height: 100%;
}

.form-link{
  width: 100%;
  border-bottom: 1px solid #dadada;
  margin-bottom: 22px;
  box-shadow: 0 0 2px 2px #efefef;
}

.monaco {
  width: 800px;
  height: 100px;
  border: 1px solid #ebebeb;
  border-radius: 4px;
}

</style>